<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    @hideModal="hideModal()"
    size="xl"
  >
    <template #header>
      <span v-if="initialItem.completed === 1">{{$t('menu.orders.complete')}}</span>
      <span v-if="initialItem.priced === 1">{{$t('menu.orders.price')}}</span>
      <span v-else>{{$t('routes.EXSBOrderCreate')}}</span>
    </template>
    <template #body>
      <Create :id-firm="idFirm" :id-contractor="idContractor" :id-case="idCase" :id-duplicated-order="idDuplicatedOrder" :id-extracted-order="idExtractedOrder" :initial-item="initialItem"></Create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '../Create'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CreateModal',
  components: {
    BaseModal,
    Create
  },

  props: ['idFirm', 'idContractor', 'idCase', 'idDuplicatedOrder', 'idExtractedOrder', 'initialItem'],

  computed: {
    ...mapGetters({
      isVisible: 'exsborder/createModal/isVisible',
      created: 'exsborder/create/created'
    })
  },

  watch: {
    created (val) {
      if (val && this.isVisible) {
        this.$emit('reload')
        this.toggleModal()
      }
    }
  },

  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsborder/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
